export const SubstitutionVehicleCodes = Object.freeze({
    "SUBSTITUTION_VEHICLE_RETURN": "subsitution_vehicle_return",
    "SUBSTITUTION_VEHICLE": "subsitution_vehicle",
    "SUBSTITUTION_VEHICLE_OTHERS": "subsitution_vehicle_other"
})